// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'

// Constants
import { ABSTRACT_SERVICE } from 'constants/proposalTypes'

// Atoms
import ItemsGrid from 'atoms/ItemsGrid'
import Chip from 'atoms/Chip'
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class WhenServiceEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
  }

  handleDateTimeClick = () => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ selectOnlyDate: null })
  }

  handleDateOnlyClick = () => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ selectOnlyDate: true })
  }

  handlePlaceholderSave = (placeholder) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { placeholder })
      }
    })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete({ type: ABSTRACT_SERVICE })
  }

  render() {
    const { proposal, field } = this.props
    const { selectOnlyDate } = proposal
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="When" onDelete={this.handleDelete}>
          <ItemsGrid>
            <Chip
              active={!selectOnlyDate}
              onClick={this.handleDateTimeClick}
            >
              Date & time
            </Chip>
            <Chip
              active={!!selectOnlyDate}
              onClick={this.handleDateOnlyClick}
            >
              Date only
            </Chip>
          </ItemsGrid>
          <Spacer />
          <TextInput
            maxLength={100}
            multiline
            label="Instructions"
            placeholder="Enter instructions here (optional)"
            defaultValue={field.placeholder || ''}
            onSave={this.handlePlaceholderSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
